const DEFAULT_LOCALE = 'en-US';

export type DateFormatStyle = 'short' | 'medium' | 'long';

const FORMAT_OPTIONS: Record<DateFormatStyle, Intl.DateTimeFormatOptions> = {
  long: { day: 'numeric', month: 'long', year: 'numeric' },
  medium: { day: 'numeric', month: 'short', year: 'numeric' },
  short: { day: '2-digit', month: '2-digit', year: 'numeric' },
};

function parseDate(value: string | Date): Date {
  if (value instanceof Date) return value;

  const isDateOnly = value.length === 10 && value[4] === '-' && value[7] === '-';
  if (isDateOnly) {
    const [year, month, day] = value.split('-').map(Number);
    const localDate = new Date(year, month - 1, day);

    if (localDate.getFullYear() !== year || localDate.getMonth() !== month - 1 || localDate.getDate() !== day) {
      return new Date(Number.NaN);
    }

    return localDate;
  }

  return new Date(value);
}

export function formatDate(date: string | Date | null | undefined, style: DateFormatStyle = 'short'): string {
  if (!date) {
    return '';
  }

  const dateObj = parseDate(date);

  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat(DEFAULT_LOCALE, FORMAT_OPTIONS[style]).format(dateObj);
}

export function formatDateTime(date: string | Date | null | undefined, style: DateFormatStyle = 'short'): string {
  if (!date) {
    return '';
  }

  const dateObj = parseDate(date);

  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    ...FORMAT_OPTIONS[style],
    hour: 'numeric',
    minute: '2-digit',
  };

  return new Intl.DateTimeFormat(DEFAULT_LOCALE, options).format(dateObj);
}
